import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { PostMobileUploadResponseDto } from '@core/mobile-upload/mobile-upload.model';
import { ToastService } from '@platform/toast/toast.service';
import { TypedDialog } from '@platform/dialog/dialog-v2.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export interface MobileUploadQrDialogData {
  locationName: string;
  customerSpaceId: string;
  createMobileUpload: () => Observable<PostMobileUploadResponseDto>;
}

@Component({
  selector: 'app-mobile-upload-qr-dialog',
  templateUrl: './mobile-upload-qr-dialog.component.html',
  styleUrls: ['./mobile-upload-qr-dialog.component.scss'],
})
export class MobileUploadQrDialogComponent implements OnInit, TypedDialog<MobileUploadQrDialogComponent, MobileUploadQrDialogData, object> {
  isPending: boolean;
  locationName: string;
  customerSpaceId: string;
  mobileUploadUrl: string;
  expirationMinutes: number;

  private createMobileUpload: () => Observable<PostMobileUploadResponseDto>;

  private destroyRef = inject(DestroyRef);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MobileUploadQrDialogData,
    public dialogRef: MatDialogRef<MobileUploadQrDialogComponent, object>,
    private toastService: ToastService,
  ) {
    this.locationName = data.locationName;
    this.customerSpaceId = data.customerSpaceId;
    this.createMobileUpload = data.createMobileUpload;
  }

  ngOnInit(): void {
    this.isPending = true;

    this.createMobileUpload()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (mobileUpload) => {
          this.mobileUploadUrl = `${window.location.origin}/customer-spaces/${this.customerSpaceId}/mobile-upload/${mobileUpload.mobileUploadId}`;
          this.expirationMinutes = mobileUpload.expirationMinutes;
          this.isPending = false;
        },
        error: () => {
          this.toastService.showErrorToast('mobile-upload.qr-dialog.creation-error');
          this.closeDialog();
        },
      });
  }

  public closeDialog(): void {
    this.dialogRef.close({});
  }
}
